import { setSportId } from "../../helpers";
/**
 * Group events received against cardConfiguration
 * @param events
 * @param cardConfig
 */
export const groupEventsBySport = (events, cardConfig) => {
    let eventsBySport = {};
    let eventSportId;
    Object.keys(cardConfig).map(sportId => {
        let availableEvents = events.filter(e => {
            eventSportId = setSportId(cardConfig, e);
            return eventSportId === sportId.toString();
        });
        eventsBySport[sportId] = availableEvents;
    });
    return eventsBySport;
};
//# sourceMappingURL=groupEventsBySport.js.map